module.exports = __webpack_public_path__ + "static/media/company_placeholder_round.90ad5bc8.svg";